import { makeUsePublication } from '@code-expert/pubsub-client';
import type { Publications } from '/imports/api/pubsub';
import { socket } from '/imports/startup/client/socket';

export const usePublication = makeUsePublication<Publications>(socket);
